<template>
  <span>
    <span v-for="(item1, index1) in item.child">
      <tr  @click="Clickproduct(item1)">
        <td class="column1">
          <b-icon v-if="item1.is_folder==true" icon="folder"></b-icon>
        </td>
        <td>
          <button type="button" class="atable">
             {{ item1.extra_name }}
          </button>
        </td>
        <td class="column2">
          <button type="button" class="noborder" v-if="item1.is_folder!=true">
            {{ item1.balance | numFormat3 }}
          </button>
        </td>
        <td class="column3">
          <button type="button" class="noborder" v-if="item1.price_register[0]">
            {{ item1.price_register[0].chakana_price | numFormat }}
          </button>
        </td>
        <td class="column3">
          <button type="button" class="noborder" v-if="item1.price_register[0]">
            {{ item1.price_register[0].optom_price | numFormat }}
          </button>
        </td>
      </tr>
      </span>
  </span> 
</template>
<script>
import $ from "jquery";
export default {
  name: "product-folder",
  data() {
    return {
      colourlist: []
    };
  },
  props: ["item"],
  created() {
    let self = this;
  },
  mounted: function() {
  },
  methods: {
  }
};
</script>